import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { selectIsElectron } from '@selectors'
import useStyles from './tip-confirmation.style'

import Icon from '@components/icon/icon.component'

import i18n from 'i18n-js'
import { SCREEN_TITLE_TIP_LOCATION } from '../../assets/i18n/strings'

const TipConfirmation = props => {
  const classes = useStyles(props)

  const isElectron = useSelector(selectIsElectron)

  const { message } = props
  const { anonymous, category, location, text } = message

  const title = `${anonymous ? 'Anonymous ' : ''}${category} tip report`

  const onClick = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`

    const win = window.open(url, '_blank')
      
    if (!isElectron) {
      win.focus()
    }
  }

  return (
    <div>
      <div className={classes.reportHeader}>
        <span className={classes.headerText}>{title}</span>
      </div>
      <div className={classes.reportBody}>
        <span>{text}</span>
      </div>
      {location &&
        <div className={classes.reportFooter}>
          <button
            className={classes.button}
            onClick={onClick}
          >
            <span className={classes.buttonText}>{i18n.t(SCREEN_TITLE_TIP_LOCATION)}</span>
            <Icon type='pin-small' />
          </button>
        </div>}
    </div>
  )
}

TipConfirmation.propTypes = {
  message: PropTypes.shape({
    anonymous: PropTypes.bool,
    category: PropTypes.string,
    location: PropTypes.shape({
      latitude: PropTypes.number,
      longtitude: PropTypes.number
    }),
    text: PropTypes.string
  }).isRequired
}

export default TipConfirmation
